const initialState = 1;

const administratorsPaginationTenantAdminReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_ADMINISTRATORS_TENANT_ADMIN_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default administratorsPaginationTenantAdminReducer;